import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Modal, ModalProps} from "@mantine/core";
import {useCallback} from "react";
import {TagDefinitionFormProvider, useTagDefinitionForm} from "./useTagDefinitionForm";
import {TagDefinitionFormFields} from "./TagDefinitionFormFields";

export interface TagDefinitionFormProps {
  options?: TagDefinitionFormOptions;
  defaultValues?: Partial<TagDefinitionFormValues>;
  onSubmit?: (values: TagDefinitionFormValues) => void;
  submitting?: boolean;
}

export interface TagDefinitionFormOptions {

}

export interface TagDefinitionFormValues {
  label: string
  description?: string
  colorHex?: string
  doNotUse?: boolean
}

export interface TagDefinitionFormDefaultValues extends Partial<TagDefinitionFormValues> {

}

export interface TagDefinitionFormRawValues {
  label?: string
  description?: string
  colorHex?: string
  doNotUse?: boolean
}

export type TagDefinitionFormType = UseFormReturnType<TagDefinitionFormRawValues, (values: TagDefinitionFormRawValues) => TagDefinitionFormRawValues>

export const TagDefinitionForm = (props: TagDefinitionFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useTagDefinitionForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        label: values.label,
        description: values.description,
        colorHex: values.colorHex,
        doNotUse: values.doNotUse,
      });
    }
  }, [form, onSubmit]);

  return (
      <TagDefinitionFormProvider form={form}>
        <form onSubmit={form.onSubmit(onFormSubmit)}>
          <TagDefinitionFormFields options={options}/>
          <Divider my="sm" variant="dotted"/>
          <Button type="submit" loading={submitting} fullWidth mt="xl">
            {t("common.action.submit", {ns: "common"})}
          </Button>
        </form>
      </TagDefinitionFormProvider>
  );
};

interface TagDefinitionFormModalProps extends TagDefinitionFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const TagDefinitionFormModal = (props: TagDefinitionFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    submitting,
    ...rest
  } = props;

  return (
      <Modal {...rest}>
        <TagDefinitionForm
            defaultValues={defaultValues}
            onSubmit={onSubmit}
            submitting={submitting}/>
      </Modal>
  );
};

